import { z } from 'zod';
export const textEntitySchema = z
    .object({
    type: z.enum(['bold', 'italic']),
    offset: z.number().int().nonnegative(),
    length: z.number().int().positive()
})
    .strict();
// Заголовок рассылки добавляет один интервал к 200 интервалам её текста.
export const textEntitiesSchema = z.array(textEntitySchema).max(201);
function boundary(text, offset) {
    if (offset <= 0 || offset >= text.length)
        return true;
    return !(text.charCodeAt(offset - 1) >= 0xd800 &&
        text.charCodeAt(offset - 1) <= 0xdbff &&
        text.charCodeAt(offset) >= 0xdc00 &&
        text.charCodeAt(offset) <= 0xdfff);
}
export function validTextEntities(text, entities) {
    return entities.every(({ offset, length }) => offset + length <= text.length && boundary(text, offset) && boundary(text, offset + length));
}
/** Данные старых сообщений и некорректная разметка дают обычный текст. */
export function readTextEntities(text, value) {
    const parsed = textEntitiesSchema.safeParse(value);
    return parsed.success && validTextEntities(text, parsed.data) ? parsed.data : [];
}
export function broadcastText(title, body, entities = []) {
    const offset = title.length + 2;
    return {
        text: `${title}\n\n${body}`,
        textEntities: [
            ...(title ? [{ type: 'bold', offset: 0, length: title.length }] : []),
            ...entities.map((entity) => ({ ...entity, offset: entity.offset + offset }))
        ]
    };
}
//# sourceMappingURL=text-entities.js.map